module.exports = __webpack_public_path__ + "img/ThemeService.15d5e22.jpg";